import { useQuery } from '@tanstack/react-query';
import { getCatalogTools } from '@/api/catalogTools.api';

/** The Toolkit's system tools, by the ids of its tool cards. */
export const useCatalogToolsQuery = (toolIds: string[]) =>
  useQuery({
    queryKey: ['catalog-tools', toolIds],
    queryFn: () => getCatalogTools(toolIds),
  });
